import { BackCardProps } from "../../back-card-variants/types";

export type ScenarioData = Omit<
  BackCardProps,
  | "onConfirm"
  | "onCancel"
  | "onBetAmountChange"
  | "betAmount"
  | "isBasic"
  | "loading"
  | "disabled"
>;

export const INITIAL_SCENARIO: ScenarioData = {
  eventName: "Netflix Top Hits",
  poolName: "Most Streamed Movie on Netflix? (May 18 – 24)",
  winCondition:
    "Correctly select the top streamed domestic movie for the listed week on Netflix (US only)",
  contestantName: "A. Remarkably Bright Creatures",
  picksRemaining: 3,
  balanceLabel: "Balance",
  balanceValue: "§3,000,000,000.00",
  oddsLabel: "3.55X",
  expReturn: "§142.00",
};
